import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../..";
import { api } from "../../../controllers/api";
import Pagination from "../../../controllers/Pagination";
import Image from "../../home/components/Image";
import {
  startLoading,
  stopLoading,
} from "../../../controllers/reducers/loader";
export interface IOrder {
  _id: string;
  orderNumber: string;
  orders: IOrderItem[];
  returned: { type: Boolean; default: false };
  returndate: Date;
  customerId: string;
  total: number;
  createdAt: string;
}
export interface IOrderItem {
  generic_name: string;
  brand_name: string;
  image: { url: string; public_id: string };
  price: number;
  quantity: number;
  name: string;
  _id: string;
  createdAt: string;
  status: string;
  orderNumber: string;
  parentId: string;
  total: number;
  merchantId: string;
  merchantEmail: string;
  merchantPhone: string;
  merchantName: string;
}
export enum OrderStatus {
  Processing = "PROCESSING",
  Shipped = "SHIPPED",
  Delivered = "DELIVERED",
  Cancelled = "CANCELLED",
  Returned = "RETURNED",
  Rejected = "REJECTED",
}
function Orders() {
  let PageSize = 20;
  const [mode, setMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { user } = useSelector((state: RootState) => state);
  const [orders, setOrders] = useState<{
    onGoingOrders: IOrderItem[];
    cancelledOrders: IOrderItem[];
    onGoingCount: number;
    cancelledCount: number;
  }>({
    onGoingOrders: [],
    cancelledOrders: [],
    onGoingCount: 0,
    cancelledCount: 0,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleMode = async (mode: boolean) => {
    setMode(!mode);
  };

  const getOrders = async (page: number) => {
    dispatch(startLoading());
    try {
      let request = await fetch(api + `/orders/${page}/${PageSize}`, {
        headers: { Authorization: "Bearer " + user?.token },
      });
      if (request.status === 404) navigate("/");
      if (request.status === 200) {
        setOrders(await request.json());
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(stopLoading());
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getOrders(page - 1);
  };
  const handleToOrder = (id: string) => {
    return () => navigate("/account/orders/" + id);
  };
  useEffect(() => {
    getOrders(0);
  }, []);
  return (
    <div className="orders-con">
      <h3>My Orders</h3>
      <div className="orders-con__header">
        <div className="orders-con__header__title">
          <p onClick={() => handleMode(true)}>
            Open / Delivered Orders ({orders?.onGoingCount})
          </p>
          <p className="active" onClick={() => handleMode(false)}>
            Cancelled / Returned Orders ({orders?.cancelledCount})
          </p>
        </div>
        <div
          className={
            "orders-con__header__indicator " + (mode ? "left" : "right")
          }
        ></div>
      </div>

      <div className="orders-con__body">
        <>
          {" "}
          {(!mode ? orders?.onGoingOrders : orders?.cancelledOrders)?.length >
          0 ? (
            (!mode ? orders?.onGoingOrders : orders?.cancelledOrders)?.map(
              (order) => (
                <div
                  className="orders-con__body__card"
                  onClick={handleToOrder(order.parentId)}
                >
                  <div className="orders-con__body__card__body">
                    <p className="orders-con__body__card__body__title">
                      Order Number - {order.orderNumber}
                    </p>
                    <p className="orders-con__body__card__body__sub">
                      Total: &#8358;{order.total.toLocaleString()}
                    </p>
                    <div className="orders-con__body__card__body__item-preview-con">
                      <div className="orders-con__body__card__body__item-preview-con__image-con">
                        <Image images={[order.image]} brand_name={order.name} />
                      </div>
                    </div>
                    <p>
                      Date Ordered: {moment(order.createdAt).format("DD-MM-YY")}
                    </p>
                    <p
                      className={
                        "order-detail-con__items__card__body__status " +
                        (order.status === OrderStatus.Shipped
                          ? "shipped"
                          : order.status === OrderStatus.Delivered
                          ? "delivered"
                          : order.status === OrderStatus.Returned
                          ? "returned"
                          : order.status === OrderStatus.Cancelled
                          ? "cancelled"
                          : order.status === OrderStatus.Rejected
                          ? "rejected"
                          : "processing")
                      }
                    >
                      {order.status === OrderStatus.Shipped
                        ? "Shipped"
                        : order.status === OrderStatus.Delivered
                        ? "Delivered"
                        : order.status === OrderStatus.Returned
                        ? "Returned"
                        : order.status === OrderStatus.Cancelled
                        ? "Cancelled"
                        : order.status === OrderStatus.Rejected
                        ? " Rejected"
                        : "Processing"}
                    </p>
                  </div>
                </div>
              )
            )
          ) : (
            <div className="orders-con__no-orders"> You have no order</div>
          )}
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={orders?.onGoingCount ? orders.onGoingCount : 0}
            pageSize={PageSize}
            onPageChange={(page) => handlePageChange(page)}
          />
        </>
      </div>
    </div>
  );
}

export default Orders;
